import { isPlatformServer } from '@angular/common';
import { Component, OnInit, PLATFORM_ID, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CountryDetail } from 'src/app/modules/shared/models/profile.mode';
import { PanelService } from 'src/app/modules/shared/services/api/panel.service';
import { RecentlySearchedService } from 'src/app/modules/shared/services/recently-searched.service';
import { LocalStorageService } from 'src/app/modules/shared/services/storage/local-storage.service';
import { LocalStorageVariables } from '../../shared/enum/localstorage-variables';
import { StoreRegionService } from '../../shared/services/store-region.service';
import { MatChipsModule } from '@angular/material/chips';

@Component({
    selector: 'search-suggestion-view',
    templateUrl: './search-suggestion-view.component.html',
    styleUrls: ['./search-suggestion-view.component.scss'],
    standalone: true,
    imports: [MatChipsModule]
})
export class SearchSuggestionViewComponent implements OnInit {
  private localStorage = inject(LocalStorageService);
  private panelService = inject(PanelService);
  private router = inject(Router);
  private dialog = inject(MatDialog);
  private recentlySearchedService = inject(RecentlySearchedService);
  private storeRegionService = inject(StoreRegionService);

  recentSearches: string[];
  trendingSearches;
  isServer: boolean;
  platformId = inject(PLATFORM_ID);

  constructor() {

    this.isServer = isPlatformServer(this.platformId);
  }

  ngOnInit(): void {
    this.getTrendingQueries();
    this.recentSearches = this.recentlySearchedService.getKeywords();
  }

  removeRecentlySearchedItem(item: string): void {
    const index = this.recentSearches.indexOf(item);
    this.recentSearches = this.recentlySearchedService.removeKeyword(index);
  }

  goToQuery(query: string) {
    this.router
      .navigate(['/search'], { queryParams: { keyword: query } })
      .then((status) => {
        this.dialog.closeAll();
      });
  }

  private getTrendingQueries() {
    let storeRegion: CountryDetail = !this.isServer
      ? this.localStorage.getItem(LocalStorageVariables.store_region)
      : this.storeRegionService.selectedRegion;
    this.panelService
      .getTrendingQueries(storeRegion?.code)
      .subscribe((result) => {
        this.trendingSearches = result;
      });
  }
}
